import cartClickEvents from 'purchase/cart/cartClickEvents';
import cartDisableAllButtons from 'purchase/cart/cartDisableAllButtons';

cartClickEvents();
cartDisableAllButtons();

const minMaxClass = 'min-max-values';

export function updateQty({ articleNumber }) {
	const input = document.querySelector(
		`input[data-quantity="true"][data-article-number="${articleNumber}"]`,
	);

	if (input) {
		handleQuantityUpdate(input);
	}
}

export function handleQuantityUpdate(input) {
	const button = input.nextElementSibling;
	const minMaxBlock = input.parentNode.querySelector(`.${minMaxClass}`);

	if (!button) return;

	if (input.value !== input.getAttribute('value')) {
		if (minMaxBlock) {
			minMaxBlock.classList.add(`${minMaxClass}--qty-updated`);
		}
		button.classList.remove('d-none');
	} else {
		if (minMaxBlock) {
			minMaxBlock.classList.remove(`${minMaxClass}--qty-updated`);
		}
		button.classList.add('d-none');
	}
}

export function qtyUpdateDisplay() {
	const isQuantityInput = e =>
		e.target.tagName === 'INPUT' &&
		e.target.hasAttribute('data-quantity') &&
		!e.target.id.includes('additionalSales');

	const handleBlur = e => {
		if (isQuantityInput(e)) {
			handleQuantityUpdate(e.target);
		}
	};

	document.addEventListener('blur', handleBlur, true);
	document.addEventListener('keyup', handleBlur, true);

	window.od.events.subscribe('productPriceTable_RowSelected', updateQty);
}

export function customProductPreview() {
	const previewModal = document.getElementById('customProduct');

	if (previewModal) {
		const customProducts = document.querySelectorAll('[data-custom-product]');

		customProducts.forEach(product => {
			product.addEventListener('click', setupModal);
		});
	}

	function setupModal(evt) {
		evt.preventDefault();
		const clickElement = evt.target;

		const data = {
			iframeContainer:
				previewModal.getElementsByClassName('iframe-container')[0],
			href: clickElement.getAttribute('href'),
		};

		const iframeExists = productLoadedCheck(data);

		if (typeof iframeExists === 'object') {
			iframeExists.classList.remove('d-none');
		} else {
			setupNewIframe(clickElement, data);
		}
	}

	function productLoadedCheck(data) {
		const iframes = Array.from(
			data.iframeContainer.getElementsByTagName('iframe'),
		);
		let matchedIframe = false;

		iframes.forEach(iframe => {
			iframe.classList.add('d-none');

			if (iframe.getAttribute('src') === data.href) {
				matchedIframe = iframe;
			}
		});

		return matchedIframe;
	}

	function setupNewIframe(clickElement, data) {
		const url = clickElement.getAttribute('href');
		const iframe = document.createElement('iframe');
		iframe.setAttribute('src', url);

		data.iframeContainer.appendChild(iframe);
	}
}
